export default "__VITE_ASSET__BmntTOuQ__"